// extracted by mini-css-extract-plugin
module.exports = {"departments":"ql-z","departmentHeading":"rl-z","departmentSection":"sl-z","departmentName":"tl-z","departmentLink":"ul-z","expandIcon":"vl-z"};